export const MAX_PHOTO_EDGE = 1600;

// Beregner målstørrelse så længste side højst er maxEdge. Forstørrer aldrig.
export function fitWithin(
  width: number,
  height: number,
  maxEdge: number = MAX_PHOTO_EDGE,
): { width: number; height: number } {
  const longest = Math.max(width, height);
  if (longest <= maxEdge) return { width, height };
  const scale = maxEdge / longest;
  return { width: Math.round(width * scale), height: Math.round(height * scale) };
}

// Tegner billedet på et canvas og eksporterer det som nyt JPEG. Et canvas bærer hverken EXIF, GPS
// eller kameradata med, så originalens metadata forlader aldrig browseren. Billedets rotation
// bages ind (imageOrientation), så fotoet står rigtigt uden EXIF.
export async function sanitizeAndCompressPhoto(file: File): Promise<Blob> {
  if (!file.type.startsWith('image/')) throw new Error('Filen er ikke et billede.');
  const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
  try {
    const { width, height } = fitWithin(bitmap.width, bitmap.height);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Billedet kunne ikke behandles.');
    ctx.drawImage(bitmap, 0, 0, width, height);
    return await new Promise<Blob>((resolve, reject) =>
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error('Billedet kunne ikke gemmes.'))),
        'image/jpeg',
        0.85,
      ),
    );
  } finally {
    bitmap.close();
  }
}
